import { SectionHeading } from "./SectionHeading";
import { workStyle } from "../../data/portfolioData";

export const WorkStyleSection = () => {
    return (
        <section
            id="work-style"
            data-testid="work-style-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="07"
                    kicker="How I work"
                    title="Some principles I keep returning to."
                />

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {workStyle.map((p) => (
                        <div
                            key={p.n}
                            data-testid={`work-principle-${p.n}`}
                            className="group rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-ink-cyan/30 md:p-8"
                        >
                            <div className="mb-4 flex items-center gap-3">
                                <span className="font-mono text-2xl font-light text-ink-cyan">
                                    {p.n}
                                </span>
                                <span className="h-px w-10 bg-[var(--ink-border-strong)] transition-colors group-hover:bg-ink-cyan/40" />
                            </div>
                            <p className="text-sm leading-relaxed text-[var(--ink-text-primary)] md:text-base">
                                {p.text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WorkStyleSection;
